// extracted by mini-css-extract-plugin
export default {"appFeatures":"AppFeatures_appFeatures__Rqdtv"};